import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { Button, DialogActions, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useResponsive } from "../../hooks/useResponsive";
import "./dialog.scss";
import { CustomButton } from "../Button/Button";
import { truncateText } from "../../utils";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default React.memo(function FormDialog({
  open,
  children,
  handleSubmit,
  handleClose,
  title,
  width,
  sx,
  buttonTxt,
  className,
  alignActions = "end",
  btnColor = "#1b3e61",
  fullWidth = false,
  disabled = false,
  cancelBtn = false,
  isLoading = false,
  showCrossIcon = true,
  crossIconFunc,
  cancelBtnTxt = "Cancel",
  onClose = true,
  isHeader = true,
  customHeaderComponent = "",
  crossIcon = true,
  ...otherProps
}) {
  const isMobile = useResponsive("down", "md");
  const defaultSx = {
    height: "100vh",
    "& .MuiPaper-root": {
      borderRadius: "8px",
      maxWidth: width ? width : "470px",
    },
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        fullWidth={fullWidth}
        keepMounted
        onClose={onClose ? handleClose : () => {}}
        onClick={(e) => e.stopPropagation()}
        aria-describedby="alert-dialog-slide-description"
        className={`form-dialog ${className}`}
        sx={sx || defaultSx}
        {...otherProps}
      >
        {isHeader && (
          <>
            {(title || customHeaderComponent) && (
              <DialogTitle className="form-dialog-title">
                {title}
                {customHeaderComponent}
              </DialogTitle>
            )}
            {crossIcon && (
              <IconButton
                aria-label="close"
                onClick={crossIconFunc ? crossIconFunc : handleClose}
                className={
                  showCrossIcon
                    ? "form-dialog-close-icon"
                    : "form-dialog-close-icon pointer-events-none"
                }
              >
                {showCrossIcon && <CloseIcon />}
              </IconButton>
            )}
          </>
        )}
        <DialogContent className="form-dialog-content">
          {children}
        </DialogContent>
        {(buttonTxt || cancelBtn) && (
          <DialogActions
            className="confirmation-dialogAction"
            sx={{ justifyContent: alignActions }}
          >
            {buttonTxt && (
              <CustomButton
                onClick={() => {
                  handleSubmit();
                }}
                disabled={disabled || isLoading}
                variant="contained"
                type="submit"
                sx={{
                  bgcolor: btnColor,
                  mr: cancelBtn ? "10px" : "0px",
                  fontSize: isMobile ? "14px" : "16px",
                  padding: isMobile ? "6px 18px" : "10px 16px",
                  fontWeight: "600",
                  textTransform: "capitalize",
                  minWidth: isMobile ? "" : "130px",
                }}
              >
                {buttonTxt}
              </CustomButton>
            )}
            {cancelBtn && (
              <CustomButton
                variant="outlined"
                sx={{
                  color: "#1B3E61",
                  border: "1px solid #1B3E61",
                  textTransform: "capitalize",
                  fontSize: "16px",
                  padding: "10px 16px",
                  fontWeight: "600",
                  opacity: "0.6",
                  minWidth: "130px",
                }}
                onClick={handleClose}
                disabled={isLoading}
                className="confirmation-action-btn"
              >
                {cancelBtnTxt}
              </CustomButton>
            )}
          </DialogActions>
        )}
      </Dialog>
    </React.Fragment>
  );
});
